import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import theme from 'theme';  //eslint-disable-line
import { MainHeaderWrapper, HeaderShadow } from '../../components/MatchWidget/styles';
import TeamHeader from '../../components/TeamHeader';
import DriverHeader from '../../components/DriverHeader';

class TeamMainHeader extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: this.props.device !== 'desktop',
    };
    this.theme = Object.assign({}, theme);
  }

  getChildContext = () => ({
    breakpoints: this.dynamicBreakPoint(process.env.REACT_APP_SITE),
  });

  componentDidMount() {
    this.resizeCallback();
    window.addEventListener('resize', this.resizeCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  dynamicBreakPoint = (site) => {
    if (site === 'gazzetta') {
      return [320, 599, 1024, 1440];
    } else if (site === 'fcinter' || site === 'forzaroma') {
      return [767, 767, 980, 1440];
    } else if (site === 'corriere') {
      return [320, 767, 767, 1440];
    } else {
      return [320, 599, 1024, 1440];
    }
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= this.dynamicBreakPointWindow(process.env.REACT_APP_SITE),
    });
  };

  dynamicBreakPointWindow = (site) => {
    if (site === 'gazzetta') {
      return 1023;
    } else if (site === 'fcinter' || site === 'forzaroma') {
      return 980;
    } else if (site === 'corriere') {
      return 767;
    } else {
      return 1023;
    }
  };

  render() {
    const {
      actions,
      dictionary,
      headerInfo,
    } = this.props;
    const { sportId, competitionId } = window.matchcenterPage;
    const { isMobile } = this.state;
    const showNextMatch = true;
    const isSoccer = sportId === 1 || sportId === '1';
    return (
      <ThemeProvider theme={this.theme}>
        <Fragment>
          {isSoccer &&
          <MainHeaderWrapper className="TeamHeaderWrapper">
            <TeamHeader
              actions={actions}
              isMobile={isMobile}
              headerInfo={headerInfo}
              dictionary={dictionary.header}
            />
            {showNextMatch &&
              <HeaderShadow
                isMobile={isMobile}
                className="HeaderShadow"
              >
                <div
                  className="matchcenter-widget"
                  data-widgettype="NextMatchWidget"
                  id="nextMatch"
                  data-teamid={window.matchcenterPage.teamId}
                  data-sportid={window.matchcenterPage.sportId}
                />
              </HeaderShadow>
            }
          </MainHeaderWrapper>
          }
          {(sportId === '6M' || sportId === '6C') &&
          <DriverHeader
            isMobile={isMobile}
            headerInfo={headerInfo}
            dictionary={dictionary.raceCompetitionLink}
            competitionId={competitionId}
            sportId={sportId}
            newspaper={process.env.REACT_APP_SITE}
          />
          }
        </Fragment>
      </ThemeProvider>
    );
  }
}

TeamMainHeader.propTypes = {
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  headerInfo: PropTypes.any,
  device: PropTypes.any,
};

export default TeamMainHeader;



// WEBPACK FOOTER //
// ./src/lib/containers/TeamMainHeader/index.js